/**
 * Design Tokens for Rebel Residential Theme
 * 
 * Extends the base aster theme tokens with Rebel Residential branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-aster/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Rebel Residential brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Rebel Residential brand colors - customize these
    // primary: '#your-primary-color',
    // secondary: '#your-secondary-color',
    // accent: '#your-accent-color',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    // Rebel Residential typography - customize these
    // heading: '"Your Heading Font", serif',
    // body: '"Your Body Font", sans-serif',
  },
};

export default tokens;
